import * as React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import "./App.css";
import "@fontsource/roboto/300.css";
import LandingPage from "./pages/landing";
import Internal from "./components/internal";
import WelcomePage from "./pages/welcome";
import SchedulesPage from "./pages/schedules";
import Maiz from "./pages/recipes/Maiz";
import Arroz from "./pages/recipes/Arroz";
import RecipesPage from "./pages/recipes/index";
import PrivacyPolicy from "./components/landing/privacy-policy";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="internal" element={<Internal />}>
          <Route index element={<Navigate to="home" replace />} />
          <Route path="home" element={<WelcomePage />}></Route>
          <Route path="laundry" element={<SchedulesPage />}></Route>
          <Route path="recipes" element={<RecipesPage />}>
            <Route path="maiz" element={<Maiz />} />
            <Route path="arroz" element={<Arroz />} />
          </Route>
        </Route>
        <Route path="/" element={<LandingPage />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </BrowserRouter>
  );
}
